module.exports = __webpack_public_path__ + "media/images/phone/story-script_tap-bg@3x-ebb325770ad51ac6b7df20f1a2c53385.png";